import { render, hydrate } from 'preact';
import { App } from './App';
import { initializeLanguageFromURL } from './i18n';
import './styles/index.css';

export function initializeApp(): void {
  // Initialize language from URL parameter before rendering
  initializeLanguageFromURL();

  const root = document.getElementById('app');
  if (root !== null) {
    // Use hydrate in production (with SSR'd HTML), render in dev (empty div)
    const hasSSRContent = root.childNodes.length > 0;
    if (hasSSRContent) {
      hydrate(<App />, root);
    } else {
      render(<App />, root);
    }
  }
}

// Execute on module load
initializeApp();
